import React, { useState } from 'react';
import {
    MessageBar,
    MessageBarBody,
    MessageBarActions,
    Button,
    makeStyles,
    tokens,
} from '@fluentui/react-components';
import { DismissRegular } from '@fluentui/react-icons';
import { isDismissed, dismissNotification } from '../utils/notificationStorage';

interface StatusBarProps {
    message: string;
    id: string;
    severity?: 'warning' | 'info';
}

const useStyles = makeStyles({
    container: {
        width: '100%',
        paddingBottom: '4px',
    },
    messageBar: {
        borderRadius: tokens.borderRadiusMedium,
    },
});

const StatusBar: React.FC<StatusBarProps> = ({ message, id, severity = 'info' }) => {
    const classes = useStyles();
    const [isVisible, setIsVisible] = useState(!isDismissed(id));

    if (!isVisible) {
        return null;
    }

    const handleDismiss = () => {
        dismissNotification(id);
        setIsVisible(false);
    };

    return (
        <div className={classes.container}>
            <MessageBar intent={severity} className={classes.messageBar}>
                <MessageBarBody>
                    <span dangerouslySetInnerHTML={{ __html: message }} />
                </MessageBarBody>
                <MessageBarActions
                    containerAction={
                        <Button
                            appearance="transparent"
                            icon={<DismissRegular />}
                            onClick={handleDismiss}
                            aria-label="Close"
                            size="small"
                        />
                    }
                />
            </MessageBar>
        </div>
    );
};

export default StatusBar;
